import { Seo } from '../components/Seo';
import { Icon } from '../components/Icon';
import { StatsBand, CtaSection } from '../components/Sections';
import { useT } from '../i18n';
import { buildTitle } from '../lib/site';

export function AboutPage() {
  const t = useT();
  const p = t.pages.about;
  return (
    <>
      <Seo
        title={buildTitle(p.title)}
        description={p.lead}
        path="/about"
      />

      <section className="page-header">
        <div className="container">
          <span className="eyebrow">{p.eyebrow}</span>
          <h1>{p.title}</h1>
          <p>{p.lead}</p>
        </div>
      </section>

      <section className="section-tight">
        <div className="container">
          <StatsBand />
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">{p.valuesEyebrow}</span>
            <h2>{p.valuesTitle}</h2>
          </div>
          <div className="grid grid-4">
            {p.values.map((v) => (
              <div className="card card-feature" key={v.title}>
                <div className="card-icon"><Icon name={v.icon as never} /></div>
                <h3>{v.title}</h3>
                <p>{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ background: 'linear-gradient(180deg, transparent, rgba(245,181,68,0.02), transparent)' }}>
        <div className="container container-narrow">
          <div className="section-head">
            <span className="eyebrow">{p.storyEyebrow}</span>
            <h2>{p.storyTitle}</h2>
          </div>
          <div className="prose">
            {p.timeline.map((item) => (
              <div key={item.year} style={{ marginBottom: 36 }}>
                <h3 style={{ marginTop: 0 }}>{item.year}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaSection />
    </>
  );
}
